import React from 'react';
import { useQuery } from '@apollo/client';

import { Appointment as AppointmentView } from './appointment';
import { GET_IS_USER_LOGGED_IN } from '../../../../../graphql/user/queries';
import {
  IConsumerAppointments,
} from '../../../../../graphql/appointments/models/get-appointments.models';
import { GET_APPOINTMENTS } from '../../../../../graphql/appointments/queries/get-appointments';

export const Appointment = (): JSX.Element => {
  const { data: { user: { isLoggedIn } } } = useQuery(GET_IS_USER_LOGGED_IN);
  const { data, loading, error } = useQuery<IConsumerAppointments>(GET_APPOINTMENTS, { skip: !isLoggedIn });
  const appointments = data?.allAppointmentsByAuthId?.edges || [];

  return (
    <AppointmentView
      appointments={appointments}
      isLoading={loading}
      isError={!!error}
    />
  );
};
